var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col" }, [
    _c(
      "div",
      { staticClass: "pb-2 flex items-end" },
      [
        _c(
          _setup.Field,
          {
            class: _vm.fieldClass,
            attrs: {
              label: "Buyer Name",
              disabled: _vm.disabled || _setup.buyerLoading,
              "error-text":
                _vm.validations !== null ? _vm.validations.buyerId : "",
            },
          },
          [
            _c(_setup.DropdownField, {
              attrs: {
                source: _setup.buyerSource,
                "text-field": "name",
                "value-field": "id",
                placeholder: "Select Buyer",
                clearable: _vm.clearable,
                searchable: "",
                debounce: "500",
              },
              on: {
                input: function ($event) {
                  return _setup.clearPackage()
                },
              },
              model: {
                value: _setup.model.buyerId,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "buyerId", $$v)
                },
                expression: "model.buyerId",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.addBuyer && _setup.entitledToEditCounterparty
          ? _c(
              _setup.Action,
              {
                staticClass: "pl-2",
                attrs: {
                  icon: "mdi mdi-plus-circle-outline pr-2",
                  disabled: _vm.disabled || _setup.buyerLoading,
                },
                on: {
                  click: function ($event) {
                    return _setup.addNewBuyer()
                  },
                },
              },
              [_vm._v("Buyer")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pb-2 flex items-end" },
      [
        _c(
          _setup.Field,
          {
            class: _vm.fieldClass,
            attrs: {
              label: "Seller Name",
              disabled: _vm.disabled || _setup.sellerLoading,
              "error-text":
                _vm.validations !== null ? _vm.validations.sellerId : "",
            },
          },
          [
            _c(_setup.DropdownField, {
              attrs: {
                source: _setup.sellerSource,
                "text-field": "name",
                "value-field": "id",
                placeholder: "Select Seller",
                clearable: _vm.clearable,
                searchable: "",
                debounce: "500",
              },
              on: {
                input: function ($event) {
                  return _setup.clearPackage()
                },
              },
              model: {
                value: _setup.model.sellerId,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "sellerId", $$v)
                },
                expression: "model.sellerId",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.addSeller && _setup.entitledToEditCounterparty
          ? _c(
              _setup.Action,
              {
                staticClass: "pl-2",
                attrs: {
                  icon: "mdi mdi-plus-circle-outline pr-2",
                  disabled: _vm.disabled || _setup.sellerLoading,
                },
                on: {
                  click: function ($event) {
                    return _setup.addNewSeller()
                  },
                },
              },
              [_vm._v("Seller")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex items-end" },
      [
        _c(
          _setup.Field,
          {
            class: _vm.fieldClass,
            attrs: {
              label: "Package",
              disabled: _vm.disabled || _setup.packageLoading,
              "error-text":
                _vm.validations !== null ? _vm.validations.packageId : "",
            },
          },
          [
            _c(_setup.DropdownField, {
              attrs: {
                source: _setup.packageSource,
                "text-field": "packageName",
                "value-field": "id",
                debounce: "600",
                placeholder: "Select Package",
                clearable: _vm.clearable,
                searchable: "",
              },
              on: {
                initialDataLoad: function ($event) {
                  return _setup.packageDataLoaded()
                },
              },
              model: {
                value: _setup.model.packageId,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "packageId", $$v)
                },
                expression: "model.packageId",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.addPackage
          ? _c(
              _setup.Action,
              {
                staticClass: "pl-2",
                attrs: {
                  icon: "mdi mdi-plus-circle-outline pr-2",
                  disabled:
                    _vm.disabled ||
                    _setup.model.sellerId === null ||
                    _setup.model.buyerId === null ||
                    _setup.packageLoading,
                },
                on: {
                  click: function ($event) {
                    return _setup.addNewPackage()
                  },
                },
              },
              [_vm._v("Package")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }